let resumeData = {
  imagebaseurl: "https://rbhatia46.github.io/",
  name: "Colin Johnson",
  role: " growing Full Stack Developer",
  linkedinId: "colin-johnson-9250b974",
  skypeid: "Your skypeid",
  roleDescription:
    " Ambitious and motivated, I am looking to become a driven and helpful member to any team.",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/colin-johnson-9250b974",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/ColinJohnson747",
      className: "fa fa-github",
    },
    {
      name: "resume",
      url:
        "https://drive.google.com/file/d/1hmiOTQT2uj93XSAvWoj6Tecp4mHlmco4/view?usp=sharing",
      className: "fa fa-bars",
    },
  ],
  aboutme:
    "I am a young and motivated developer, looking to grow my knowledge and skills. I have participated in rigorous and thorough training from the UNC Coding bootcamp, in addition to learing and practicing code in my own time. I am practiced in HTML, CSS, Javascript, Reactjs, and more. In addition to this I have experince working with different creation engines, such as Unreal 4 and Unity. I look forward to working with your team!",
  address: "",
  website: "https://rbhatia46.github.io",
  email: "colinjohnson747@gmail.com",
  github: "https://github.com/ColinJohnson747",
  phone: "919-747-1503",
  education: [
    {
      UniversityName: "The University of North Carolina Coding Boot Camp",
      specialization: "Certification in Fullstack Development",
      MonthOfPassing: "Aug",
      YearOfPassing: "2020",
      Achievements: "",
    },
  ],
  work: [],
  skillsDescription:
    "Trained in fullstack development, my skills encompass some of the following:",
  skills: [
    {
      skillname: "HTML5",
    },
    {
      skillname: "CSS",
    },
    {
      skillname: "JAVASCRIPT",
    },
    {
      skillname: "MongoDB",
    },
    {
      skillname: "MySql",
    },
    {
      skillname: "NodeJS",
    },
    {
      skillname: "Reactjs",
    },
  ],
  portfolio: [
    {
      name: "Weather Forcaster",
      description:
        "A web app to look up the current weather in differnt locations",
      imgurl: "images/portfolio/weather.png",
      gitUrl: "https://github.com/ColinJohnson747/Weather-Forcast",
      appUrl: "https://colinjohnson747.github.io/Weather-Forcast/",
    },
    {
      name: "Date-Night",
      description: "An application that makes picking dinner and drink easy!",
      imgurl: "images/portfolio/Date-Night.png",
      gitUrl: "https://github.com/ColinJohnson747/Date-Night",
      appUrl: "https://colinjohnson747.github.io/Date-Night/",
    },
    {
      name: "Employee Tracker",
      description: "A CLI application to manage and sort employees",
      imgurl: "images/portfolio/employeetracker.png",
      appUrl: "https://www.youtube.com/watch?v=XkYS7L2fEnw&feature=youtu.be",
      gitUrl: "https://github.com/ColinJohnson747/Employee-Tracker",
    },
    {
      name: "Fitness Tracker",
      description:
        "A web app that allows you to record and save exercices and workouts, and will track them for you.",
      imgurl: "images/portfolio/exercise.jpg",
      appUrl: "https://workouttracker351.herokuapp.com/",
      gitUrl: "https://github.com/ColinJohnson747/Workout-Tracker",
    },
    {
      name: "Note Taker",
      description: "A web app that you can write and save notes in.",
      imgurl: "images/portfolio/note.jpeg",
      appUrl: "https://mynewnotemaker.herokuapp.com/",
      gitUrl: "https://github.com/ColinJohnson747/Note-Taker",
    },
    {
      name: "GameGo!",
      description:
        "A web application that you can find video games based on preference, and save them to your account.",
      imgurl: "images/portfolio/videogames.png",
      gitUrl: "https://github.com/ColinJohnson747/Game-Go",
      appUrl: "https://game-go-randomizer.herokuapp.com/",
    },
  ],
  testimonials: [
    {
      description: "This is a sample testimonial",
      name: "Some technical guy",
    },
    {
      description: "This is a sample testimonial",
      name: "Some technical guy",
    },
  ],
};

export default resumeData;
